export const PREAUTH_NOTE_ID_KEY = 'preauth-note-id'
